import { render, staticRenderFns } from "./dialog_register.vue?vue&type=template&id=58c4354b"
import script from "./dialog_register.vue?vue&type=script&lang=js"
export * from "./dialog_register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports